import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/Index'
import IndexSale from '@/pages/IndexSale'
import Login from '@/pages/Login'
import AccountLogin from '@/pages/AccountLogin'
import AgreeMent from '@/pages/AgreeMent'
import Protocol from '@/pages/Protocol'

import Assess from '@/pages/order-manage/Assess'
import ConfirmOrder from '@/pages/order-manage/ConfirmOrder'
import refundDetail from '@/pages/order-manage/refundDetail'
import PlaceOrder from '@/pages/order-manage/PlaceOrder'
import ConfirmOrderAdmin from '@/pages/order-manage/ConfirmOrderAdmin'

import OrderDetail from '@/pages/order-manage/OrderDetail'
import PaySuccess from '@/pages/order-manage/PaySuccess'
import OperateSuccess from '@/pages/order-manage/OperateSuccess'
import OrderDetailSale from '@/pages/order-manage/OrderDetailSale'
import MyOrderAdmin from '@/pages/order-manage/MyOrderAdmin'
import OrderDetailAdmin from '@/pages/order-manage/OrderDetailAdmin'
import orderSpeed from '@/pages/order-manage/orderSpeed'
import AddFollowSale from '@/pages/order-manage/AddFollowSale'


import EditData from '@/pages/personal/EditData'
import News from '@/pages/personal/News'
import NewsDetail from '@/pages/personal/NewsDetail'
import PersonalData from '@/pages/personal/PersonalData'

import AddCard from '@/pages/my-wallet/AddCard'
import BalanceDetail from '@/pages/my-wallet/BalanceDetail'
import BalanceDetailSale from '@/pages/my-wallet/BalanceDetailSale'
import BalanceList from '@/pages/my-wallet/BalanceList'
import BalanceListSale from '@/pages/my-wallet/BalanceListSale'
import BankcardManage from '@/pages/my-wallet/BankcardManage'
import Recharge from '@/pages/my-wallet/Recharge'
import Wallet from '@/pages/my-wallet/Wallet'
import WalletSale from '@/pages/my-wallet/WalletSale'
import WithdrawBalance from '@/pages/my-wallet/WithdrawBalance'
import WithdrawBalanceSucc from '@/pages/my-wallet/WithdrawBalanceSucc'

import BindMobile from '@/pages/BindMobile';

import utils from '../assets/jslibs/utils'

Vue.use(Router)

let router = new Router({
    routes: [{
        path: '/',
        name: '/',
        component: Index
    },{
        path: '/login',
        name: 'login',
        component: Login,
    },{
        path: '/index',
        name: 'index',
        component: Index,
    },{
        path: '/index-sale',
        name: 'index-sale',
        component: IndexSale
    },{
        path: '/account-login',
        name: 'account-login',
        component: AccountLogin
    },{
        path: '/agreement',
        name: 'agreement',
        component: AgreeMent     
    },{
        path: '/protocol',
        name: 'protocol',
        component: Protocol     
    },{
        path: '/assess',
        name: 'assess',
        component: Assess
    },{
        path: '/refund-detail',
        name: 'refund-detail',
        component: refundDetail
    },{
        path: '/place-order',
        name: 'place-order',
        component: PlaceOrder
    },{
        path: '/confirm-order',
        name: 'confirm-order',
        component: ConfirmOrder
    },{
        path: '/confirmorder-admin',
        name: 'confirmorder-admin',
        component: ConfirmOrderAdmin
    },{
        path: '/order-speed',
        name: 'order-speed',               
        component: orderSpeed
    },{
        path: '/addfollow-sale',
        name: 'addfollow-sale',               
        component: AddFollowSale
    },{
        path: '/order-detail',
        name: 'order-detail',
        component: OrderDetail
    },{
        path: '/orderdetail-sale',
        name: 'orderdetail-sale',
        component: OrderDetailSale
    },{
        path: '/orderdetail-admin',
        name: 'orderdetail-admin',
        component: OrderDetailAdmin
    },{
        path: '/myorder-admin',
        name: 'myorder-admin',
        component: MyOrderAdmin
    },{
        path: '/pay-success',
        name: 'pay-success',
        component: PaySuccess
    },{
        path: '/operate-success',
        name: 'operate-success',
        component: OperateSuccess
    },{
        path: '/personal-data',
        name: 'personal-data',
        component: PersonalData
    },{
        path: '/news',
        name: 'news',
        component: News
    },{
        path: '/news-detail',
        name: 'news-detail',
        component: NewsDetail
    },{
        path: '/edit-data',
        name: 'edit-data',
        component: EditData
    },{
        path: '/add-card',
        name: 'add-card',
        component: AddCard
    },{
        path: '/balance-detail',
        name: 'balance-detail',
        component: BalanceDetail
    },{
        path: '/balancedetail-sale',
        name: 'balancedetail-sale',
        component: BalanceDetailSale
    },{
        path: '/balance-list',
        name: 'balance-list',
        component: BalanceList
    },{
        path: '/balanceList-sale',
        name: 'balanceList-sale',
        component: BalanceListSale
    },{
        path: '/bankcard-manage',
        name: 'bankcard-manage',
        component: BankcardManage
    },{
        path: '/recharge',
        name: 'recharge',
        component: Recharge
    },{
        path: '/wallet',
        name: 'wallet',
        component: Wallet
    },{
        path: '/wallet-sale',
        name: 'wallet-sale',
        component: WalletSale
    },{
        path: '/withdraw-balance',
        name: 'withdraw-balance',
        component: WithdrawBalance
    },{
        path: '/withdraw-balancesucc',
        name: 'withdraw-balancesucc',
        component: WithdrawBalanceSucc
    },{
        path: '/bind-mobile',
        name: 'bind-mobile',
        component:BindMobile
    }

    ]
})
export default router;